exports = module.exports = require("../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-size-0-8 {\n  font-size: 0.8rem;\n}\n\n.text-size-1 {\n  font-size: 1rem;\n  cursor: pointer;\n}\n.icon-sizes {\n  width: 3.5rem !important; \n}\n.activeAdd {\n  border: 1px solid #ffeba6;\n  padding-top: 14px !important;\n  padding-bottom: 14px !important;\n  box-shadow: 1px 2px 5px #d6d3d3;\n}\n\n.fa-check:before {\n  color: #28be22 !important;\n}\n\n@media (max-width:514px) {\n  hr {\n    margin-top: 0rem !important;\n    margin-bottom: 0rem !important;\n    border: 0;\n    border-top: 1px solid rgba(0, 0, 0, .1);\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/cart/cart.component.css
// module id = ../../../../../src/app/components/cart/cart.component.css
// module chunks = main